module.exports = __webpack_public_path__ + "static/media/V_pictos-01.7ab04e07.svg";